import Service from "../../AuthService";
const AdvanceWithdraw = {
    getAdvanceWithdraw(page) {
        return Service.get("/advance_withdraw?page="+page);
    },
    showAdvanceWithdraw(id) {
        return Service.get("/advance_withdraw/" + id);
    },
    updateAdvanceWithdraw(id, data) {
        return Service.put("/advance_withdraw/" + id, data);
    },
    createAdvanceWithdraw(data) {
        return Service.post("/advance_withdraw", data);
    },
    deleteAdvanceWithdraw(id) {
        return Service.delete("/advance_withdraw/" + id);
    },
};
export default AdvanceWithdraw;
